module.exports = __webpack_public_path__ + "static/12-be4b8e5275af9d1be67cd371ec6c7913.jpg";